var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M40 10C41.2982 11.731 42 13.8363 42 16V18H22V16C22 13.8363 22.7018 11.731 24 10H14C13.4696 10 12.9609 10.2107 12.5858 10.5858C12.2107 10.9609 12 11.4696 12 12V54C12 54.5304 12.2107 55.0391 12.5858 55.4142C12.9609 55.7893 13.4696 56 14 56H50C50.5304 56 51.0391 55.7893 51.4142 55.4142C51.7893 55.0391 52 54.5304 52 54V12C52 11.4696 51.7893 10.9609 51.4142 10.5858C51.0391 10.2107 50.5304 10 50 10H40Z",
    fill: "#2086BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 10H50C50.5304 10 51.0391 10.2107 51.4142 10.5858C51.7893 10.9609 52 11.4696 52 12V54C52 54.5304 51.7893 55.0391 51.4142 55.4142C51.0391 55.7893 50.5304 56 50 56H14C13.4696 56 12.9609 55.7893 12.5858 55.4142C12.2107 55.0391 12 54.5304 12 54V12C12 11.4696 12.2107 10.9609 12.5858 10.5858C12.9609 10.2107 13.4696 10 14 10H24",
    stroke: "#2086BD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18V16C22 13.3478 23.0536 10.8043 24.9289 8.92893C26.8043 7.05357 29.3478 6 32 6C34.6522 6 37.1957 7.05357 39.0711 8.92893C40.9464 10.8043 42 13.3478 42 16V18H22Z",
    stroke: "#2086BD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.b498a4f7a6dad558ff71d91da0423b5c.svg";
export { ForwardRef as ReactComponent };